/* eslint-disable arrow-body-style */
import React, { useState, useEffect, useMemo } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import { Typography, Button, useWindowSize, ScalableImage } from "design_system/src";

import "./Banner.scss";
import { useDispatch } from "react-redux";
import {
  clearApplicationLoanTime,
  clearApplicationPartnership,
  clearApplicationVehicle,
} from "store/actions/application";

const DESKTOP_MIN_WIDTH = 1200;
const TABLET_MIN_WIDTH = 600;

const SingleBanner: React.FC = () => {
  const mobileBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/moto-credito-cdmx-descubre-tu-limite-registro-formulario-mobile.jpg";
  const tabletBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/moto-credito-cdmx-descubre-tu-limite-registro-formulario-tablet.jpg";
  const desktopBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/moto-credito-cdmx-descubre-tu-limite-registro-formulario-desktop.jpg";

  const { width: windowWidth } = useWindowSize();

  const bannerUrl = useMemo(() => {
    if (windowWidth > DESKTOP_MIN_WIDTH) return desktopBannerImg;
    if (windowWidth > TABLET_MIN_WIDTH) return tabletBannerImg;
    return mobileBannerImg;
  }, [windowWidth]);

  const dispatch = useDispatch();

  const clickToFinancialForm = (alliedCompany: string | null = null) => {
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());
    dispatch(clearApplicationPartnership());

    if (alliedCompany) {
      ReactGA.event("CTA_discount_delivery_drivers", {
        category: "Financial Form",
        label: "click modal of delivery drivers discount",
        value: alliedCompany
      });
    }
  };

  return (
    <section className="dso_container_desktop">
      <div
        className={
          `singleBanner${windowWidth >= DESKTOP_MIN_WIDTH ? " desktop" : ""}${windowWidth >= TABLET_MIN_WIDTH && windowWidth < DESKTOP_MIN_WIDTH ? " tablet" : ""}`
        }
      >
        <ScalableImage
          src={bannerUrl}
          alt="Moto a crédito con Ozon by Payjoy: descubre tu límite y estrena tu moto. Crédito con Buró Flexible, paga en cuotas semanales. Solo en CDMX."
          desktopWidth={100}
          mobileWidth={100}
          loading="eager"
          fetchpriority="high"
        />
        <div className="singleBannerButton">
          <Link to="/financia-tu-moto" onClick={() => clickToFinancialForm()} className="">
            <Button
              variant="principal"
              scale={windowWidth >= DESKTOP_MIN_WIDTH ? "large" : "small"}
              className="w_100_per_mobile"
            >
              <Typography weight="600" scale={windowWidth >= DESKTOP_MIN_WIDTH ? "large" : "medium"}>Solicita tu crédito</Typography>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SingleBanner;
